/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_ZeitarbeitsverhaeltnisInputs */



/**

* @param {_Field_ZeitarbeitsverhaeltnisInputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
export const _field_zeitarbeitsverhaeltnis = /** @type {((inputs?: _Field_ZeitarbeitsverhaeltnisInputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_ZeitarbeitsverhaeltnisInputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return /** @type {LocalizedString} */ ("Zeitarbeitsverhältnis")
});